import { Injectable } from '@angular/core';

@Injectable()
export class WindowRef {
    constructor() {}

    getNativeWindow() {
        return window;
    }
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/util/window.ref.ts